__turbopack_context__.v({
  "clearBtn": "MappingTool-module-scss-module__2gkkFa__clearBtn",
  "formInput": "MappingTool-module-scss-module__2gkkFa__formInput",
  "formInputHidden": "MappingTool-module-scss-module__2gkkFa__formInputHidden",
  "loader": "MappingTool-module-scss-module__2gkkFa__loader",
  "placeholder": "MappingTool-module-scss-module__2gkkFa__placeholder",
  "submitBtn": "MappingTool-module-scss-module__2gkkFa__submitBtn",
  "submitBtnDisabled": "MappingTool-module-scss-module__2gkkFa__submitBtnDisabled",
  "toolArea": "MappingTool-module-scss-module__2gkkFa__toolArea",
  "uploadArea": "MappingTool-module-scss-module__2gkkFa__uploadArea",
  "uploadAreaActive": "MappingTool-module-scss-module__2gkkFa__uploadAreaActive",
  "uploadIcon": "MappingTool-module-scss-module__2gkkFa__uploadIcon",
});
